import * as React from "react";
import { LabelledElement } from "../../../components/labelled-element/LabelledElement.component";
import Select from "react-select";
import { useEffect, useState } from "react";
import { getReactSelectStyleClasses } from "../../../style/style-functions";
import { COLOR_FLAVIA_BLUE } from "../../../style/predefined-colors";
import { ColorSelect } from "../../../components/color-select/ColorSelect.component";
import { busService } from "../../../../modules/bus";
import { RosBagPointCloudTopicsAnswerMessage, RosBagPointCloudTopicsRequestMessage } from "../../../../messages/rosbag/RosBagMessages";
import { MessageService } from "../../../services/message.service";
import { HTMLTooltipWrapper } from "../../../components/html-tooltip/HTMLTooltipWrapper.component";
import { useTranslation } from "react-i18next";
import { ModelUploadContentUtils } from "./ModelUploadContent.util";
export function RosbagContent({ fileName, onChange }) {
    const { t } = useTranslation();
    const [topics, setTopics] = useState([]);
    const [currentOptions, setCurrentOptions] = useState({
        topic: "",
        identifier: "Lidar",
        position: [0, 1, 0],
        rotation: [0, 0, 0],
        color: COLOR_FLAVIA_BLUE,
        pointSize: 100,
        syncWithOthers: false,
        useTransform: false
    });
    useEffect(() => {
        onChange(currentOptions);
    }, [currentOptions]);
    useEffect(() => {
        setCurrentOptions(Object.assign(Object.assign({}, currentOptions), { topic: topics[0] }));
    }, [topics]);
    // TODO: Do we need to show a loading spinner here?
    useEffect(() => {
        const connection = busService.connection("RosbagUploadDialog");
        connection
            .askByMessageType(new RosBagPointCloudTopicsRequestMessage(fileName), RosBagPointCloudTopicsAnswerMessage)
            .then((answer) => {
            setTopics(answer.topics);
        })
            .catch((error) => {
            MessageService.showMessage("error", t("upload:error-no-rosbag-topics", "Failed to get Rosbag topics: ${error}", { error: error }));
        });
    }, [fileName]);
    return (React.createElement("section", { className: "model-upload-dialog-content" },
        React.createElement(HTMLTooltipWrapper, { tooltip: t("upload:input-rosbag-identifier-tooltip", "The identifier will be used to identify the imported data in the scene") },
            React.createElement(LabelledElement, { label: t("upload:input-rosbag-identifier", "Import identifier:") },
                React.createElement("input", { type: "text", value: currentOptions.identifier, onChange: (e) => {
                        setCurrentOptions(Object.assign(Object.assign({}, currentOptions), { identifier: e.target.value }));
                    } }))),
        React.createElement(HTMLTooltipWrapper, { tooltip: t("upload:input-rosbag-topic-tooltip", "The topic from which the point cloud data will be extracted") },
            React.createElement(LabelledElement, { label: t("upload:input-rosbag-topic", "Topic:") },
                React.createElement(Select, { onChange: (option) => {
                        var _a;
                        setCurrentOptions(Object.assign(Object.assign({}, currentOptions), { topic: (_a = option === null || option === void 0 ? void 0 : option.value) !== null && _a !== void 0 ? _a : "" }));
                    }, options: topics.map((topic) => ({ value: topic, label: topic })), value: { value: currentOptions.topic, label: currentOptions.topic }, classNames: getReactSelectStyleClasses(), menuPlacement: "auto", menuPortalTarget: document.body }))),
        React.createElement(HTMLTooltipWrapper, { tooltip: t("upload:select-rosbag-pointcloud-color-tooltip", "The color of the point cloud") },
            React.createElement(ColorSelect, { color: currentOptions.color, label: t("upload:select-rosbag-pointcloud-color", "Color:"), onColorChanged: (color) => {
                    setCurrentOptions(Object.assign(Object.assign({}, currentOptions), { color: color }));
                } })),
        React.createElement(HTMLTooltipWrapper, { tooltip: t("upload:input-rosbag-point-size-pixels-tooltip", "The size of the points in the point cloud") },
            React.createElement(LabelledElement, { label: t("upload:input-rosbag-point-size-pixels", "Maximum point size (pxels):"), horizontal: true },
                React.createElement("input", { type: "number", value: currentOptions.pointSize, onChange: (e) => {
                        setCurrentOptions(Object.assign(Object.assign({}, currentOptions), { pointSize: parseFloat(e.target.value) }));
                    } }))),
        React.createElement("div", { className: "labelled-checkbox-container", "data-tooltip": t("upload:checkbox-rosbag-sync-data-tooltip", "If this option is set, the extracted point cloud will be synchronized with other users in the session") },
            React.createElement("input", { type: "checkbox", checked: currentOptions.syncWithOthers, onChange: (e) => {
                    setCurrentOptions(Object.assign(Object.assign({}, currentOptions), { syncWithOthers: e.target.checked }));
                } }),
            React.createElement("label", null, t("upload:checkbox-rosbag-sync-data-label", "Sync point cloud with other users"))),
        React.createElement("div", { className: "labelled-checkbox-container", "data-tooltip": t("upload:checkbox-rosbag-custom-transform-tooltip", "If this option is set, you can specify a custom position and rotation for the imported point cloud") },
            React.createElement("input", { type: "checkbox", checked: currentOptions.useTransform, onChange: (e) => {
                    setCurrentOptions(Object.assign(Object.assign({}, currentOptions), { useTransform: e.target.checked }));
                } }),
            React.createElement("label", null, t("upload:checkbox-rosbag-custom-transform-label", "Use custom transform"))),
        currentOptions.useTransform && (React.createElement(React.Fragment, null,
            ModelUploadContentUtils.createTripleNumberInputPosition(currentOptions.position, (position) => {
                setCurrentOptions(Object.assign(Object.assign({}, currentOptions), { position: position }));
            }),
            ModelUploadContentUtils.createTripleNumberInputRotation(currentOptions.rotation, (rotation) => {
                setCurrentOptions(Object.assign(Object.assign({}, currentOptions), { rotation: rotation }));
            })))));
}
